module.exports = __webpack_public_path__ + "img/plant_grey.1cd80c1e.svg";